import { Column } from '@codeparva/ui-components-library';
import React, { Fragment } from 'react';
import { weakKey } from '../../../../utilities/weakKey';
import { FooterTypes } from './footerTypes';
import { useVariant } from './hooks/VariantContext';
import { footerConstants } from './helpers/constants';
import { useThemeContext } from './hooks/themeContext';
import { getTextColor } from './helpers/ColorSelectorHelper';

const getTextAlignment = (currentVariant: FooterTypes.TFooterVariantModes) => {
  switch (currentVariant) {
    case 'footer-1':
      return 'right-tablet';
    default:
      return 'centered';
  }
};
export const selectClassNameForTermsPrivacySiteMapAndDisclaimer = (
  variant: FooterTypes.TFooterVariantModes
) => {
  switch (variant) {
    case 'footer-1':
      return 'is-4';
    case 'footer-2':
      return 'termsVariantTwo is-3';
    case 'new-footer-1':
      return 'termsVariantTwo is-4 newLinksColumn';
    default:
      return 'termsVariantThree is-3';
  }
};
export const FooterTermsPrivacySiteMapAndDisclaimer = ({
  termsPrivacySiteMapAndDisclaimer,
}: FooterTypes.TTermsDisclamerAndSiteMap) => {
  const currentVariant = useVariant();
  const currTheme = useThemeContext();

  const getTermsPrivacySiteMapAndDisclaimer = (
    info: FooterTypes.TTermsAndPrivacy[]
  ) => {
    if (currentVariant === 'footer-3' || currentVariant === 'footer-2') {
      info = info.slice(0, footerConstants.termsCountVariantThree);
    }
    return info.map((data, counter: number) => {
      return (
        <Fragment key={weakKey(data)}>
          <p className="mb-0">
            <a
              href={data.linkUrl}
              target={data.newTab ? '__blank' : ''}
              rel="noreferrer"
              className={`termsAndPrivacyLink has-text-${getTextColor(
                currTheme
              )}`}
            >
              {data.linkName}
            </a>
          </p>
          {counter !== info.length - 1 && info.length !== 1 && ' | '}
        </Fragment>
      );
    });
  };
  return (
    <Column
      className={`has-text-${getTextColor(
        currTheme
      )} has-text-${getTextAlignment(
        currentVariant
      )} ${selectClassNameForTermsPrivacySiteMapAndDisclaimer(
        currentVariant
      )} is-flex is-justify-content-center`}
    >
      {getTermsPrivacySiteMapAndDisclaimer(termsPrivacySiteMapAndDisclaimer)}
    </Column>
  );
};
